module.exports = __webpack_public_path__ + "img/ts.71bebe9c.jpg";